import axios from "axios";

const publicAuthApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const ONBOARDING_TOKEN_KEY = "otpOnboardingToken";
export const ONBOARDING_IDENTIFIER_KEY = "otpOnboardingIdentifier";

const getResponseData = (request) => request.then((response) => response.data);

export const exchangeFirebaseToken = ({ channel, idToken }) =>
  getResponseData(
    publicAuthApi.post("/auth/firebase/verify", {
      channel,
      idToken,
    }),
  );

export const completeOtpOnboarding = ({
  onboardingToken,
  name,
  role,
  language,
  acceptedTerms,
}) =>
  getResponseData(
    publicAuthApi.post("/auth/firebase/complete-onboarding", {
      onboardingToken,
      name,
      role,
      language,
      acceptedTerms,
    }),
  );

export const legacyPasswordLogin = ({ username, password }) =>
  getResponseData(
    publicAuthApi.post("/login", {
      username,
      password,
    }),
  );

export const passwordRegister = ({
  name,
  username,
  password,
  role,
  language,
  acceptedTerms,
}) =>
  getResponseData(
    publicAuthApi.post("/register", {
      name,
      username,
      password,
      role,
      language,
      acceptedTerms,
    }),
  );

export default publicAuthApi;
